// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TAyc","footer":"styles_footer__WyOQ3","passCodeTooltip":"styles_passCodeTooltip__3yzjf"};